import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import axios from 'axios';
import { Layout, Spin, Alert } from 'antd';
import Header from './header';
import Sidebar from './sidebar';
import { loadGoogleMaps } from '../utils/loadGoogleMaps';

const { Content } = Layout;

const RoadDetailsForm = () => {
    const { id } = useParams();
    const [roadDetails, setRoadDetails] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        const fetchRoadDetails = async () => {
            try {
                const response = await axios.get(`https://ward3-chandrapur-api.palikaapp.com/api/road/${id}/details`);
                setRoadDetails(response.data);
            } catch (error) {
                setError(error);
            } finally {
                setLoading(false);
            }
        };
        fetchRoadDetails();
    }, [id]);

    useEffect(() => {
        if (roadDetails && roadDetails.track) {
            const initMap = async () => {
                try {
                    const googleMaps = await loadGoogleMaps("AIzaSyB4Z418MHwoKYfrN9wq28zZvgqtfwmNXa4");
                    const map = new googleMaps.Map(document.getElementById("map"), {
                        zoom: 14,
                        center: { lat: parseFloat(roadDetails.track[0].latitude), lng: parseFloat(roadDetails.track[0].longitude) },
                        mapTypeId: "terrain",
                    });

                    const flightPlanCoordinates = roadDetails.track.map((point) => ({
                        lat: parseFloat(point.latitude),
                        lng: parseFloat(point.longitude),
                    }));

                    const flightPath = new googleMaps.Polyline({
                        path: flightPlanCoordinates,
                        geodesic: true,
                        strokeColor: "#FF0000",
                        strokeOpacity: 1.0,
                        strokeWeight: 2,
                    });

                    flightPath.setMap(map);
                } catch (error) {
                    console.error("Failed to load Google Maps:", error);
                }
            };

            initMap();
        }
    }, [roadDetails]);

    if (loading) {
        return (
            <div className="flex items-center justify-center h-screen">
                <Spin tip="Loading..." />
            </div>
        );
    }

    if (error) {
        return (
            <div className="p-4">
                <Alert message="Error" description={error.message} type="error" showIcon />
            </div>
        );
    }

    return (
        <Layout>
            <Header />
            <Layout className='pt-20'>
                <Sidebar />
                <Content className="p-4 lg:p-8">
                    <div className="bg-white p-6 rounded-lg shadow-md max-w-5xl mx-auto">
                        <h2 className="text-center text-2xl font-semibold mb-8">बाटोको बिस्तृत विवरण</h2>
                        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 text-lg">
                            <div>
                                <span className="font-bold">नाम (Nepali):</span> {roadDetails.nameNep}
                            </div>
                            <div>
                                <span className="font-bold">नाम (English):</span> {roadDetails.nameEng}
                            </div>
                            <div>
                                <span className="font-bold">अहिलेको चौडाइ:</span> {roadDetails.currentPurposeWidth}
                            </div>
                            <div>
                                <span className="font-bold">पछिको चौडाइ:</span> {roadDetails.futurePurposeWidth}
                            </div>
                            <div>
                                <span className="font-bold">सुरुवात वडा:</span> {roadDetails.startWard}
                            </div>
                            <div>
                                <span className="font-bold">अन्तिम वडा:</span> {roadDetails.endWard}
                            </div>
                            <div>
                                <span className="font-bold">सुरुवात टोल:</span> {roadDetails.startTole}
                            </div>
                            <div>
                                <span className="font-bold">अन्तिम टोल:</span> {roadDetails.endTole}
                            </div>
                            <div>
                                <span className="font-bold">सुरुवात बिन्दु:</span> {roadDetails.startLandMark}
                            </div>
                            <div>
                                <span className="font-bold">अन्तिम बिन्दु:</span> {roadDetails.endLandMark}
                            </div>
                        </div>
                        <div
                            id="map"
                            className="h-96 w-full rounded-lg shadow-md mt-8 mb-4"
                        ></div>
                        <div className="text-lg">
                            <div>
                                <span className="font-bold">Remarks:</span> {roadDetails.remarks}
                            </div>
                        </div>
                    </div>
                </Content>
            </Layout>
        </Layout>
    );
};

export default RoadDetailsForm;
